export default __webpack_public_path__ + "static/media/kitchen1-2048w.47421371.webp";